import { useEffect, useRef, useState } from 'react';

export function useInterval(callback, delay) {
  const savedCallback = useRef();
  const delayInSec = Math.round(delay / 1000);
  const [countdown, setCountdown] = useState(delayInSec);

  function reset() {
    setCountdown(delayInSec);
  }

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function run() {
      setCountdown(countdown - 1);
      if (countdown === 0) {
        savedCallback.current();
        setCountdown(delayInSec);
      }
    }

    if (delay !== null) {
      const interval = setInterval(run, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [callback, delay]);

  return { countdown, reset };
}
